const features = [
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '全站支持 1080P 及以上清晰度，部分片源提供 4K 超清选项，给你影院级视觉享受。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速加载',
    desc: '多 CDN 智能调度，全国节点加速，打开即播无需等待，告别缓冲烦恼。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全端适配',
    desc: '手机、平板、电脑完美适配，横竖屏自动切换，随时随地窝着看。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全纯净',
    desc: '无弹窗广告、无恶意跳转、无强制安装，纯净观影环境让你安心沉浸。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold text-accent-600 tracking-widest uppercase mb-2">Why Us</p>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            平台特色
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            为什么千万影迷选择被窝网电影
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((f) => (
            <div
              key={f.title}
              className="bg-background-100 rounded-xl p-6 md:p-7 border border-background-200/60 text-center group hover:border-accent-300/40 transition-all duration-300"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 rounded-2xl bg-accent-50 flex items-center justify-center">
                <i className={`${f.icon} text-accent-500 text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                {f.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}